import { useMySSOUrl } from '@sentara-health/sentara-api-hooks-core';
import React, { useState, useContext } from 'react';
import { GlobalContext, isAvMed } from 'context';
import { useNavigate } from 'react-router-dom';
import { useAdobeAnalytics } from '@sentara-health/platform-analytics';
import {
  TilesIds,
  NavigateConst,
  MyPlanTabs,
  ANALYTICS_MESSAGES,
  domainForSegment,
  getAnalyticsBaseConfig,
  SCREEN_NAMES,
  errorhandler,
  navigateToExternalUrl,
  generateCustomAdobeContentTitle,
} from 'common';

import {
  Loader,
  Button
} from '@sentara-health/optimahealth_web';
interface Tile {
  name: string;
  icon: React.JSX.Element;
  id: string;
}
interface Tiles {
  allTiles: Tile[];
}



const HomeTiles = ({ allTiles }: Tiles) => {
  const { getFeature, ssoEndPoints } = useContext(GlobalContext);
  const { contentListingItemClicked } = useAdobeAnalytics();  

  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);

  const openUrl = (url: string | undefined) => {
    window.open(url, isAvMed() ? '_blank' : '_self');
  };


  // Redirect to Oracle contact us page
  const redirectToContact = () => {
    // Check if ContactusSalesForce property of getFeature is falsy, 
    // If it's truthy, navigate to homeContactUs
    if (!getFeature?.ContactusSalesForce) {
      const form = document.getElementById('contactUS') as HTMLFormElement;
      form.submit();
    } else {
      navigate(NavigateConst.homeContactUs);
    }
  };
  // Redirect to SSO URL 
  const redirectToUrl = (type: string) => {
    if (isAvMed()) {
      openUrl(type)
    } else {
      getAPIUrl(type);
    }
  };

  // Redirect to SSO URL 
  const redirectUrl = (urltype: string, type: string) => {
    if (isAvMed()) {
      openUrl(urltype)
    } else if (getFeature?.VirtualFirstHealthPlan) {
      navigate(type)
    } else {
      getAPIUrl(urltype);
    }
  };
  //Create an object of tile actions
  const tileActions: any = {
    [TilesIds.findDoctor]: () => navigate(NavigateConst.findADoctor),
    [TilesIds.viewClaims]: () => navigate(NavigateConst.medicalClaimsURL),
    [TilesIds.ViewIDCard]: () => navigate(NavigateConst.memberIDCard),
    [TilesIds.BenefitsSnapshot]: () => navigate(NavigateConst.benefits),
    [TilesIds.MyProfile]: () => {
      navigate(NavigateConst.profile);
    },
    [TilesIds.UrgentCareSearch]: () => getAPIUrl(ssoEndPoints?.UrgentCareSearch),
    [TilesIds.ContactUs]: () => redirectToContact(),
    [TilesIds.MyPlan]: () => navigate(`${NavigateConst.myPlan + MyPlanTabs.overViewID}`),
    [TilesIds.FormsAndDocuments]: () => navigate(NavigateConst.formsAndDocuments),
    [TilesIds.Authorizations]: () => navigate(NavigateConst?.authorization),
    [TilesIds.VirtualVisit]: () => redirectUrl(ssoEndPoints?.VirtualVisitSSO, ssoEndPoints?.virtualVisitUrl),
    [TilesIds.PayMonthlyPremium]: () => isAvMed() && getFeature?.PayMonthlyPremiumPage ? navigate('/home/pay-monthly-premium') : redirectToUrl(ssoEndPoints?.PayMonthlyPremium),
    [TilesIds.HealthReimbursementAccount]: () => openUrl(ssoEndPoints?.HealthReimbursementAccount),
    [TilesIds.HealthSavingsAccount]: () => navigateToExternalUrl(ssoEndPoints?.healthSavingAccounts),
    [TilesIds.SmartShopper]: () => openUrl(ssoEndPoints?.smartShopperURL),
    [TilesIds.CalculateTreatmentCosts]: () => openUrl(ssoEndPoints?.CalculateTreatmentCostUrl),
    [TilesIds.RxSavings]: () => openUrl(ssoEndPoints?.rxSavingsURL),
  };



  const clickTile = (tile: Tile, index: number) => {
    const eventType = tile.name;
    const customDashboardTile = generateCustomAdobeContentTitle(tile.name, ANALYTICS_MESSAGES.DASHBOARD_TILE_CLICK_SUFFIX);
    contentListingItemClicked({
      segment: `${domainForSegment}/dashboard`,
      contentListing: {
        eventType,
        listing: {
          content: [
            {
              contentId: tile.id,
              contentTitle: customDashboardTile,
              itemPosition: index + 1,
            },
          ],
        },
      },
    });

    const action = tileActions[tile.id];
    action?.();
  };
  const { SSOUrlType } = useMySSOUrl();
  const getAPIUrl = async (type: string) => {
    setLoading(true);
    const res = await SSOUrlType(type); // Get SSO URL from API
    if (res?.data?.ssoUrl) {
      window.open(res?.data?.ssoUrl, '_blank'); // Open SSO URL in a new tab
    } else if (res?.errorCode) {
      errorhandler(res?.errorCode);
    }
    setLoading(false);
  };

  return (
    <>
      {allTiles?.length > 0 &&
        allTiles.map((item: Tile, index: number) => {
          return (
            <Button
              onClick={() => clickTile(item, index)}
              data-testid={`${item.id}`}
              variant="icontitle_btn"
              className="grid-col border_0"
              key={item.id}
            >
              <span>{item.icon}</span>
              {item.name}
            </Button>
          );
        })}
      {loading && <Loader />}
    </>
  );
};

export default HomeTiles;
